<template>
  <div class="tz-container">
    <div>
      <div>
        <b-carousel
          id="carousel-fade"
          style="text-shadow: 0px 0px 2px #000"
          fade
          indicators
        >
          <b-carousel-slide
            v-for="(item, $index) in carouselList"
            :key="$index"
          >
            <template v-slot:img>
              <b-img :src="item.img" @click="openTab(item.link)" />
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>
      <b-navbar toggleable="lg" type="dark" variant="info" class="tz-nav">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav class="tz-flex-v-center">
          <b-navbar-nav>
            <b-nav-item
              v-for="(item, $index) in navList"
              :key="$index"
              :href="'#' + $index"
              @click="goPage($index)"
              :class="$index == pageId ? 'nav-select' : ''"
            >
              <b-img :src="item.icon" />
              {{ item.name }}
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <tz-second v-if="pageId == 0" :competition="competition" />
    <tz-first v-if="pageId == 1" :competition="competition" />
    <tz-ranking v-if="pageId == 2" :competition="competition" />
    <div v-if="pageId == 3">
      <b-container class="tz-center-content" v-html="competition.summary" />
    </div>
    <div v-if="pageId == 4">
      <b-container class="tz-center-content" v-html="competition.rule" />
    </div>

    <div v-if="pageId == 5">
      <b-container class="tz-center-content" v-html="competition.prize" />
    </div>

    <tz-news
      style="margin-top: 1rem"
      v-if="pageId == 6"
      :news.sync="competition.news"
    >
    </tz-news>

    <tz-news
      style="margin-top: 1rem"
      v-if="pageId == 7"
      :news.sync="competition.schoolNews"
    >
    </tz-news>

    <tz-footer />
  </div>
</template>
<script>
import Frame from "./frame.vue";
import Footer from "@/components/footer.vue";
import Ranking from "./ranking.vue";
import First from "./first.vue";
import Second from "./second.vue";
import News from "./news.vue";
import { getToken } from "@/utils/auth";
import * as competitionApi from "@/api/competition";
export default {
  data() {
    return {
      compId: 0,
      pageId: 0,
      competition: null,
      carouselList: [],
      navList: [
        {
          name: "大赛首页",
          icon: "/static/image/home_icon.png",
        },
        {
          name: "大赛任务",
          icon: "/static/image/comp_item_icon.png",
        },
        {
          name: "大赛排名",
          icon: "/static/image/ranking_icon.png",
        },
        {
          name: "赛制赛程",
          icon: "/static/image/race_icon.png",
        },
        {
          name: "竞赛方式",
          icon: "/static/image/rule_icon.png",
        },
        {
          name: "奖项设置",
          icon: "/static/image/prize_icon.png",
        },
        {
          name: "大赛新闻",
          icon: "/static/image/news_icon.png",
        },
        {
          name: "院校风采",
          icon: "/static/image/school_news_icon.png",
        },
      ],
    };
  },
  components: {
    "tz-frame": Frame,
    "tz-footer": Footer,
    "tz-ranking": Ranking,
    "tz-first": First,
    "tz-second": Second,
    "tz-news": News,
  },
  created() {
    this.compId = this.$route.query.id;
    let token = getToken();

    let jump = location.hash.substring(1) == "3";
    if (!token && !jump) {
      this.$router.push({
        path: "/login",
      });
    }
    if (this.compId) {
      competitionApi.get({ compId: this.compId }).then((res) => {
        if (res.code == 200) {
          this.competition = res.data;
          this.competition.bannerList.forEach((item) => {
            this.carouselList.push({
              img: item.img,
              link: item.link,
            });
          });
        }
      });
    }
  },
  mounted() {
    this.pageId = location.hash.substring(1);
  },
  methods: {
    jump(item) {
      // window.open(link)
    },
    goPage(val) {
      this.pageId = val;
    },
    openTab(link) {
      // 判断是不是链接
      if (isValidUrl(link)) {
        window.open(link);
      }
    },
    isValidUrl(link) {
      const urlPattern =/^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;
      return urlPattern.test(link);
    },
  },
};
</script>
<style scoped>
.tz-container {
  padding-bottom: 3rem;
}
.tz-center-content {
  background: white;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
  padding-left: 5rem;
  padding-right: 5rem;
  max-width: 65rem;
}
.tz-center-content img {
  max-width: 60rem;
}
.tz-box2-content {
  display: flex;
  justify-content: space-between;
}
.tz-icon {
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  vertical-align: middle;
}
.tz-nav {
  background-color: #0263d3 !important;
  width: 100%;
  max-width: 1920px;
  padding: 0;
}
.tz-flex-v-center {
  justify-content: center;
}
.tz-logo {
  width: 2rem;
  height: 2rem;
  margin-left: 1.5rem;
  /* margin-top: -5px; */
}
.tz-logo-name {
  width: 7rem;
  height: auto;
}

em {
  font-style: normal !important;
}
li {
  font-weight: bolder;
  font-size: 110%;
  margin-left: 1rem;
}
.nav-select {
  background-color: #ff6600;
}
.nav-item:hover {
  background-color: #ff6600;
}
.nav-item:focus {
  background-color: #ff6600;
}
.nav-link:focus {
  background-color: #ff6600;
}
</style>


// WEBPACK FOOTER //
// src/views/competition/index.vue